module.exports = __webpack_public_path__ + "img/filter_2.e65d2a02.svg";